import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-yes-no-confirmation1',
  templateUrl: './yes-no-confirmation1.component.html',
  styleUrls: ['./yes-no-confirmation1.component.scss']
})
export class YesNoConfirmation1Component implements OnInit {

  @Input() title: any
  @Input() currentTabIndex:any;
  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) { 

  }

  ngOnInit() {
    localStorage.setItem("arActiveTab",this.currentTabIndex);
  }

  confirm() {
    this.bsModalRef.hide()
    this.triggerEvent(true)
  }

  decline() {
    this.triggerEvent(false)
    this.bsModalRef.hide()
  }
  
  triggerEvent(item) {
    this.event.emit({ data: item, res: 200 });
  }

}
